






	// @ts-ignore
    import _ from './MTips.ts'; export default _;
